import { Route, Switch } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import withErrorBoundary from 'src/core/common/components/withErrorBoundary';
import { routes } from 'src/core/constants/routes';
import { LocalStorageKey } from 'src/core/constants/storage';

import { MultiEntityHubOverviewPageContainer } from './MultiEntityHubOverviewPageContainer';
import { MultiEntityHubSettingsPageContainer } from './MultiEntityHubSettingsPageContainer';
import { IntroModal } from '../components/IntroModal/IntroModal';

export const MultiEntityHubContainer = withErrorBoundary({
  scope: 'multi-entity-hub',
  team: 'control',
})(() => {
  const [introModalAlreadyDisplayed, toggleIntroModalEncountered] =
    useLocalStorage<boolean>(
      LocalStorageKey.MultiEntityHubIntroModalEncountered,
      false,
    );

  return (
    <>
      {!introModalAlreadyDisplayed && (
        <IntroModal onModalHidden={() => toggleIntroModalEncountered(true)} />
      )}
      <Switch>
        <Route exact path={routes.ORGANISATION_REPORTING.path}>
          <MultiEntityHubOverviewPageContainer />
        </Route>
        <Route path={routes.ORGANISATION_SETTINGS.path}>
          <MultiEntityHubSettingsPageContainer />
        </Route>
      </Switch>
    </>
  );
});
